import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Item from '../components/Item'
import { menu } from '../components/menu'
import { searchIcon } from '../images/index'

const Search = ({ ...props }) => {
	const [searchText, setSearchText] = useState('')
	return (
		<div>
			<div className={`searchBar py-1 px-4 pr-1  flex justify-between ${searchText && 'removeSearchBR'}`}>
				<input
					className=' bg-transparent outline-none '
					id='search'
					placeholder='Search'
					onChange={(e) => {
						console.log(e.target.value, e.target.id)
						setSearchText(e.target.value)
					}}
					value={searchText}
					onFocus={() => {
						props.setShowSearchPage(true)
					}}
					onBlur={() => {
						if (searchText === '') props.setShowSearchPage(false)
					}}
				></input>
				<div className={`searchIcon rounded-full p-1 ${searchText && 'hidden'}`}>
					<img className='h-6' src={searchIcon} alt='' />
				</div>
			</div>
			{searchText && (
				<div className='searchResults px-4  py-3 pt-2 rounded-[1.2rem]'>
					{menu.map((category, categoryID) => {
						return category.items.map((item, key) => {
							let itemEntry = Object.entries(item)[0]
							if (itemEntry[0].toLowerCase().includes(searchText.toLowerCase())) {
								return (
									<Link
										className='py-2'
										key={key}
										to={'/category'}
										onClick={(e) => {
											console.log(e.target, 'target ')
											e.preventDefault()
											setSearchText('')
											props.setShowSearchPage(false)
											props.setCategoryID(categoryID)
										}}
									>
										<Item name={itemEntry[0]} price={itemEntry[1]}></Item>
									</Link>
								)
							}
						})
					})}
				</div>
			)}
		</div>
	)
}

export default Search
